/**
 * Как вошли на этом устройстве: по бейджу или по логину.
 *
 * Нужно, чтобы вернуть человека туда, откуда он входил: сессия по бейджу живёт
 * смену и без refresh-ключа, по её истечении сервер отвечает 401 — и терминал
 * склада раньше уходил на форму логина и пароля, которых у сотрудника нет.
 * Метка переживает выход и 401 намеренно: терминал остаётся «бейджевым».
 */
const KEY = 'wms_auth_mode';

export function setAuthMode(mode) {
  try {
    if (mode) localStorage.setItem(KEY, mode);
    else localStorage.removeItem(KEY);
  } catch { /* приватный режим — вернёмся на обычный вход */ }
}

export function isBadgeSession() {
  try { return localStorage.getItem(KEY) === 'badge'; } catch { return false; }
}

/** Куда вести на вход: терминал с бейджами — на скан бейджа, иначе — на логин. */
export function loginPath() {
  return isBadgeSession() ? '/badge' : '/login';
}
